import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const DataDeletion = () => {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText('complementossa@gmail.com');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-screen bg-white px-6 py-12 max-w-3xl mx-auto" data-testid="data-deletion-page">
      <div className="mb-6">
        <Link to="/login" className="text-sm text-blue-600 hover:underline" data-testid="back-to-login-link">← Volver al inicio</Link>
      </div>
      <h1 className="text-3xl font-black text-[#111111] mb-2">Instrucciones para Eliminar Datos</h1>
      <p className="text-sm text-[#52525B] mb-8">Última actualización: Abril 2026</p>

      <div className="space-y-6 text-sm text-[#333] leading-relaxed">
        <section>
          <p className="text-base">
            En <strong>Grupo Sach</strong> respetamos su privacidad. Si desea que eliminemos toda la información personal asociada a su perfil de Facebook, WhatsApp o pedidos realizados con nosotros, puede solicitarlo siguiendo las instrucciones a continuación.
          </p>
        </section>

        <section className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
          <h2 className="text-lg font-bold text-[#111111] mb-3">Cómo solicitar la eliminación de sus datos</h2>

          <ol className="list-decimal ml-6 space-y-3">
            <li>
              <strong>Envíe un correo electrónico</strong> a:
              <div className="mt-2 flex items-center gap-2">
                <code className="bg-white px-3 py-1 rounded border border-gray-300 font-mono text-sm">
                  complementossa@gmail.com
                </code>
                <button
                  onClick={copyEmail}
                  className="text-xs px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
                  data-testid="copy-email-btn"
                >
                  {copied ? '✓ Copiado' : 'Copiar'}
                </button>
              </div>
            </li>
            <li>
              <strong>Use el siguiente asunto:</strong> <em>Eliminación de Datos – [su nombre o ID de Facebook]</em>
            </li>
            <li>
              <strong>Incluya en el cuerpo del correo:</strong>
              <ul className="list-disc ml-6 mt-2 space-y-1">
                <li>Su nombre completo (como aparece en Facebook o WhatsApp)</li>
                <li>El número de teléfono que usó para contactarnos por WhatsApp (si aplica)</li>
                <li>El nombre de la página de Facebook con la que ha interactuado (ej: SACH Automatizaciones, Complementos, etc.)</li>
                <li>Si recuerda alguna conversación o pedido específico, por favor menciónelo</li>
              </ul>
            </li>
            <li>
              <strong>Espere nuestra confirmación.</strong> Procesaremos su solicitud en un plazo de hasta <strong>30 días hábiles</strong> y le enviaremos un correo confirmando que sus datos han sido eliminados.
            </li>
          </ol>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">¿Qué datos eliminamos?</h2>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Su perfil de Facebook/WhatsApp en nuestro sistema (nombre, foto, ID)</li>
            <li>Todas las conversaciones e historial de mensajes</li>
            <li>Datos de contacto (teléfonos, direcciones)</li>
            <li>Pedidos completados (excepto los que tengamos obligación legal de conservar por requisitos contables/fiscales por 5 años)</li>
            <li>Notas internas y etiquetas asociadas a su perfil</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">Datos que NO podemos eliminar</h2>
          <p>Por requerimientos legales, fiscales o contables, podemos estar obligados a conservar:</p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Facturas y comprobantes de compra (según la ley fiscal de Guatemala — hasta 5 años).</li>
            <li>Registros de pagos y transacciones.</li>
            <li>Registros de envíos coordinados con empresas de paquetería.</li>
          </ul>
          <p className="mt-2">
            Estos datos se mantienen únicamente con fines legales y no se utilizan para marketing ni para contactarle.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">Eliminación desde Facebook</h2>
          <p>
            Si solo desea desconectar nuestra app de su cuenta de Facebook, también puede hacerlo desde:
          </p>
          <p className="mt-2">
            <a
              href="https://www.facebook.com/settings?tab=business_tools"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
              data-testid="fb-business-tools-link"
            >
              Configuración de Facebook → Apps y sitios web → Herramientas comerciales
            </a>
          </p>
          <p className="mt-2 text-xs text-[#52525B]">
            Esto no elimina los datos que ya tenemos almacenados, solo evita que recibamos información futura. Para eliminación completa, debe enviar el correo descrito arriba.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">Más información</h2>
          <p>
            Para más detalles sobre cómo manejamos sus datos, lea nuestra{' '}
            <Link to="/privacy" className="text-blue-600 underline" data-testid="privacy-link">
              Política de Privacidad
            </Link>{' '}
            y nuestros{' '}
            <Link to="/terms" className="text-blue-600 underline" data-testid="terms-link">
              Términos del Servicio
            </Link>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default DataDeletion;
